<template>
	<div class="kq-page">
		<!-- 无权限保护：仅业务员可见 -->
		<div v-if="!isSales" class="kq-forbidden">
			<i class="el-icon-lock"></i>
			<div class="fb-title">无权访问</div>
			<div class="fb-tip">客勤填报仅对业务员角色开放。</div>
		</div>

		<template v-else>
			<div class="kq-toolbar">
				<span class="kq-title">客勤填报</span>
				<el-date-picker v-model="reportDate" type="date" size="small" :clearable="false"
					value-format="yyyy-MM-dd" placeholder="填报日期" class="kq-date"
					@change="onDateChange"></el-date-picker>
				<el-button type="primary" size="small" icon="el-icon-check" :loading="submitting"
					:disabled="!fields.length" @click="onSubmit">提交</el-button>
				<span class="kq-tip">当天可新填或修改；历史日期只能修改已有记录（如改客户类型），不能补录</span>
			</div>

			<div v-if="!fields.length" class="kq-empty">
				暂无可填报字段，请联系管理员在后台「客情配置」中添加字段。
			</div>

			<div v-else class="kq-form" v-loading="loading">
				<div class="kq-field" v-for="f in fields" :key="f.id">
					<div class="kq-label">{{ f.name }}</div>
					<el-input v-model="content[String(f.id)]" size="small" maxlength="200"
						:placeholder="'请填写' + f.name"></el-input>
				</div>
			</div>

			<!-- 我的记录：本人历史填报 + 自己的客情汇总 -->
			<div class="kq-mine">
				<div class="kq-mine-head">
					<span class="kq-title">我的记录</span>
					<span class="kq-sum" v-if="myTotalFans !== null">
						我的总粉：<b>{{ formatNum(myTotalFans) }}</b>
						<template v-if="myTotal !== null">（共 {{ myTotal }} 次填报）</template>
					</span>
				</div>
				<el-table :data="historyRows" size="small" empty-text="暂无填报记录" v-loading="historyLoading"
					border style="width:100%">
					<el-table-column prop="date" label="日期" width="110" align="center"></el-table-column>
					<el-table-column v-for="f in fields" :key="'h' + f.id" :label="f.name" align="center"
						min-width="80">
						<template slot-scope="scope">{{ cellVal(scope.row, f.id) }}</template>
					</el-table-column>
					<el-table-column label="更新时间" width="150" align="center">
						<template slot-scope="scope">{{ scope.row.updatedText }}</template>
					</el-table-column>
					<el-table-column label="操作" width="80" align="center">
						<template slot-scope="scope">
							<el-button type="text" size="small" @click="onEdit(scope.row)">修改</el-button>
						</template>
					</el-table-column>
				</el-table>
				<el-pagination class="kq-pager" background layout="prev, pager, next" :total="myTotal || 0"
					:page-size="pageSize" :current-page.sync="pageNo" @current-change="loadHistory"
					v-if="(myTotal || 0) > pageSize"></el-pagination>
			</div>
		</template>
	</div>
</template>

<script>
import bizApi from '../api/bizApi.js';

export default {
	name: 'kqReport',
	data() {
		return {
			reportDate: this.today(),
			fields: [],
			content: {},
			loading: false,
			submitting: false,
			// 我的记录
			historyRows: [],
			historyLoading: false,
			pageNo: 1,
			pageSize: 20,
			myTotal: null,
			myTotalFans: null
		};
	},
	computed: {
		isSales() {
			return this.userStore && this.userStore.isBizSales;
		}
	},
	methods: {
		today() {
			const d = new Date();
			return d.getFullYear() + '-' + ('0' + (d.getMonth() + 1)).slice(-2) + '-' + ('0' + d.getDate()).slice(-2);
		},
		formatNum(v) {
			if (v === null || v === undefined) return '0';
			const n = Number(v);
			return Number.isInteger(n) ? String(n) : String(n);
		},
		async loadFields() {
			try {
				this.fields = (await bizApi.kqFields()) || [];
			} catch (e) {
				this.fields = [];
			}
		},
		async loadMyReport() {
			this.loading = true;
			try {
				const report = await bizApi.kqMyReport(this.reportDate);
				const map = {};
				if (report && report.content) {
					try {
						const obj = JSON.parse(report.content);
						Object.keys(obj || {}).forEach(k => { map[String(k)] = obj[k]; });
					} catch (e) { /* ignore */ }
				}
				this.content = map;
			} catch (e) {
				this.content = {};
			} finally {
				this.loading = false;
			}
		},
		async loadHistory() {
			this.historyLoading = true;
			try {
				const d = await bizApi.kqReportHistory({ pageNo: this.pageNo, pageSize: this.pageSize });
				this.myTotal = (d && d.total) || 0;
				this.myTotalFans = (d && d.myTotalFans !== undefined) ? d.myTotalFans : null;
				this.historyRows = ((d && d.list) || []).map(r => {
					let obj = {};
					try { obj = JSON.parse(r.content || '{}') || {}; } catch (e) { /* ignore */ }
					return {
						id: r.id,
						date: this.fmtDate(r.reportDate),
						obj,
						updatedText: (r.updatedTime || '').substring(0, 16)
					};
				});
			} catch (e) {
				this.historyRows = [];
			} finally {
				this.historyLoading = false;
			}
		},
		cellVal(row, fieldId) {
			const v = row.obj[String(fieldId)];
			return v === undefined || v === null || v === '' ? '-' : v;
		},
		// 后端 reportDate 是 UTC ISO串,直接截前10位会差一天,按本地时区格式化
		fmtDate(v) {
			const d = new Date(v);
			if (!(d instanceof Date) || isNaN(d)) return (v || '').substring(0, 10);
			const p = x => String(x).padStart(2, '0');
			return d.getFullYear() + '-' + p(d.getMonth() + 1) + '-' + p(d.getDate());
		},
		onEdit(row) {
			this.reportDate = row.date;
			this.loadMyReport();
			window.scrollTo({ top: 0, behavior: 'smooth' });
			this.$message.info('正在修改 ' + row.date + ' 的记录，改完点「提交」');
		},
		onDateChange() {
			this.loadMyReport();
		},
		async onSubmit() {
			if (this.submitting) return;
			this.submitting = true;
			try {
				await bizApi.kqReportSubmit(this.reportDate, this.content);
				this.$message.success('提交成功');
				this.loadHistory();
			} catch (e) {
				// http 拦截器已弹出错误提示
			} finally {
				this.submitting = false;
			}
		}
	},
	async mounted() {
		await this.loadFields();
		await this.loadMyReport();
		this.loadHistory();
	}
};
</script>

<style scoped lang="scss">
.kq-page {
	height: 100%;
	overflow-y: auto;
	padding: 20px 28px;
	box-sizing: border-box;
	text-align: left;
	color: #333;

	.kq-forbidden {
		display: flex;
		flex-direction: column;
		align-items: center;
		justify-content: center;
		height: 100%;
		color: #909399;

		i {
			font-size: 46px;
		}

		.fb-title {
			margin-top: 14px;
			font-size: 18px;
			font-weight: 600;
		}

		.fb-tip {
			margin-top: 8px;
			font-size: 13px;
		}
	}

	.kq-toolbar {
		display: flex;
		align-items: center;
		gap: 12px;
		margin-bottom: 20px;

		.kq-title {
			font-size: 18px;
			font-weight: 600;
			margin-right: 8px;
		}

		.kq-tip {
			font-size: 12px;
			color: #909399;
		}
	}

	.kq-empty {
		padding: 40px;
		text-align: center;
		color: #909399;
		font-size: 14px;
	}

	.kq-form {
		max-width: 520px;

		.kq-field {
			margin-bottom: 16px;

			.kq-label {
				font-size: 14px;
				margin-bottom: 6px;
				color: #606266;
			}
		}
	}

	.kq-mine {
		margin-top: 32px;

		.kq-mine-head {
			display: flex;
			align-items: center;
			gap: 16px;
			margin-bottom: 12px;

			.kq-title {
				font-size: 18px;
				font-weight: 600;
			}

			.kq-sum {
				font-size: 13px;
				color: #606266;

				b {
					color: #e6a23c;
					font-size: 15px;
				}
			}
		}

		.kq-pager {
			margin-top: 12px;
			text-align: right;
		}
	}
}
</style>
